import { Link } from 'react-router-dom'
import { formatShortDate, formatTime, formatCurrency } from '@utils/formatters'
import { CITIES } from '@utils/geolocation' // Import CITIES
import { useCityContext } from '@contexts/LocationContext'
import Button from '@components/Button'
import Badge from '@components/Badge'
import { DISABLE_LAST_UNITS_BADGE } from '@config/features'
import './Hero.css'

const Hero = ({ event, hasOtherEvents }) => {
  const { isRibeirao } = useCityContext()
  
  const instagramUrl = isRibeirao 
    ? 'https://www.instagram.com/arqbeirao/' 
    : 'https://www.instagram.com/arqbncd/'

  if (!event) {
    if (hasOtherEvents) {
      return null
    }
    return (
      <section className="hero hero--placeholder">
        <div className="hero__container container">
          <div className="hero__content hero__content--centered">
            <h1 className="hero__title">
              No momento, não temos <span className="hero__title--gradient">experiências ARQ</span> com vendas liberadas.
            </h1>
            <p className="hero__subtitle">
              Para mais informações e novidades sobre próximos eventos, acompanhe nosso <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="hero__link">Instagram oficial</a>.
            </p>
          </div>
        </div>
      </section>
    )
  }

  const {
    event_id,
    name,
    description,
    start_date,
    date,
    main_image_url,
    total_stock,
    sold_stock,
    unit_id,
    ticket_types,
  } = event

  const minPrice = ticket_types && ticket_types.length > 0
    ? Math.min(...ticket_types.map(ticket => ticket.value_cents)) / 100
    : undefined;


  const displayDate = start_date || date; // Prioritize start_date, fallback to date

  const isAlmostSoldOut = total_stock && sold_stock && (sold_stock / total_stock >= 0.9);

  // Determine location based on custom location or unit_id
  const citySlug = Object.keys(CITIES).find(key => CITIES[key].unit_id === unit_id);
  const locationName = event.location_name || (citySlug ? `Arq ${CITIES[citySlug].name}` : 'Local não informado');


  return (
    <section className="hero" style={{ backgroundImage: `url(${main_image_url})` }}>
      <div className="hero__overlay" />

      <div className="hero__container container">
        <div className="hero__layout">
          <div className="hero__content">
            {isAlmostSoldOut && !DISABLE_LAST_UNITS_BADGE ? (
              <Badge variant="warning" size="lg">
                Últimos ingressos disponíveis!
              </Badge>
            ) : null}

            <h1 className="hero__title">{name}</h1>

            <div className="hero__meta">
              <span className="hero__date">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {formatShortDate(displayDate)} às {formatTime(displayDate)}
              </span>
              <span className="hero__location">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                {locationName}
              </span>
            </div>

            {description && (
              <p className="hero__description">{description}</p>
            )}

            <div className="hero__footer">
              {minPrice !== undefined ? (
                <div className="hero__price">
                  <span className="hero__price-label">A partir de</span>
                  <span className="hero__price-value">{formatCurrency(minPrice)}</span>
                </div>
              ) : null}

              <div className="hero__actions">
                <Link to={`/${CITIES[citySlug]?.slug || ''}/evento/${event_id}`}>
                  <Button variant="primary" size="lg">
                    Comprar agora
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="hero__image-wrapper">
            <img 
              src={main_image_url || '/placeholder-event.jpg'} 
              alt={name} 
              className="hero__image"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
